import * as React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Typography
} from '@mui/material';

type ConfirmDialogProps = {
    open: boolean;
    title?: string;
    message?: string;
    confirmText?: string;
    cancelText?: string;
    confirmColor?: 'primary' | 'error' | 'warning' | 'inherit' | 'secondary' | 'success' | 'info';
    loading?: boolean;
    onClose: () => void;
    onConfirm: () => void;
};

export function ConfirmDialog({
    open,
    title = 'Are you sure?',
    message = 'This action cannot be undone.',
    confirmText = 'Yes',
    cancelText = 'Cancel',
    confirmColor = 'error',
    loading = false,
    onClose,
    onConfirm
}: ConfirmDialogProps) {
    // Prevent closing by backdrop or escape while loading
    const handleClose = (_: unknown, reason?: 'backdropClick' | 'escapeKeyDown') => {
        if (loading && (reason === 'backdropClick' || reason === 'escapeKeyDown')) return;
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <Typography variant="body1">{message}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>{cancelText}</Button>
                <Button
                    variant="contained"
                    color={confirmColor}
                    onClick={onConfirm}
                    disabled={loading}
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}